/* src/routes/projects/Memoizer.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import PostTop from "../../../_components/Post-Top.svelte.js";
import PostContents from "../../../_components/Post-Contents.svelte.js";
import Prism from "../../../_components/PrismJS.svelte.js";
import PostSection from "../../../_components/Post-Section.svelte.js";
import OpenInGithub from "../../../_components/Open-In-Github.svelte.js";

function create_default_slot_1(ctx) {
	let h1;
	let t0;
	let t1;
	let p0;
	let t2;
	let a0;
	let t3;
	let t4;
	let t5;
	let p1;
	let a1;
	let img0;
	let img0_src_value;
	let t6;
	let a2;
	let img1;
	let img1_src_value;
	let t7;
	let a3;
	let img2;
	let img2_src_value;
	let t8;
	let prism0;
	let t9;
	let p2;
	let t10;
	let t11;
	let h20;
	let t12;
	let t13;
	let p3;
	let t14;
	let t15;
	let prism1;
	let t16;
	let h21;
	let t17;
	let t18;
	let p4;
	let a4;
	let t19;
	let t20;
	let t21;
	let h22;
	let t22;
	let t23;
	let p5;
	let t24;
	let a5;
	let t25;
	let t26;
	let t27;
	let h30;
	let t28;
	let t29;
	let prism2;
	let t30;
	let h31;
	let t31;
	let t32;
	let prism3;
	let t33;
	let p6;
	let t34;
	let current;

	prism0 = new Prism({
			props: {
				language: "csharp",
				code: `// Result will be cached for the lifetime of this application
[Cache]
public string HelloWorld() => "Hello World!";

// Result will be cached for 500 Milliseconds
[Cache(500)]
public string HelloWorld() => "500 Millisecond Cache";

// Result will be cached for 5 seconds
[Cache(5, Time.Second)]
public string HelloWorld() => "5 Second Cache";
`
			}
		});

	prism1 = new Prism({
			props: {
				language: "csharp",
				code: `Install-Package Memoizer.NETStandard
`
			}
		});

	prism2 = new Prism({
			props: {
				language: "csharp",
				code: `[Cache]
public BigInteger Fib(int n)
{
    if (n < 2) return n;
    return Fib(n - 1) + Fib(n - 2);
}
Fib(5); // 0.003s
Fib(50); // 0.003s
Fib(300); // 0.010s
Fib(1000); // 0.013s
`
			}
		});

	prism3 = new Prism({
			props: {
				language: "csharp",
				code: `// Brute Force method that does not Use Memoization
public BigInteger Fib(int n)
{
    if (n < 2) return n;
    return Fib(n - 1) + Fib(n - 2);
}

Fib(5); // 0.003s
Fib(50); // 977s (16 Minutes)
Fib(300); // Come back tomorrow
Fib(1000); // Years!!
`
			}
		});

	return {
		c() {
			h1 = element("h1");
			t0 = text("Memoizer");
			t1 = space();
			p0 = element("p");
			t2 = text("This is a quick and easy way of adding ");
			a0 = element("a");
			t3 = text("Memoization");
			t4 = text("/Caching to your C# project.");
			t5 = space();
			p1 = element("p");
			a1 = element("a");
			img0 = element("img");
			t6 = space();
			a2 = element("a");
			img1 = element("img");
			t7 = space();
			a3 = element("a");
			img2 = element("img");
			t8 = space();
			create_component(prism0.$$.fragment);
			t9 = space();
			p2 = element("p");
			t10 = text("Calls to cached method with matching arguments will be cached meaning only the first call with a unique set or args will execute the internal code.");
			t11 = space();
			h20 = element("h2");
			t12 = text("Installation");
			t13 = space();
			p3 = element("p");
			t14 = text("Add the NuGet package to your project.");
			t15 = space();
			create_component(prism1.$$.fragment);
			t16 = space();
			h21 = element("h2");
			t17 = text("Why");
			t18 = space();
			p4 = element("p");
			a4 = element("a");
			t19 = text("Memoization");
			t20 = text(" is an optimization technique used primarily to speed up computer programs by storing the results of expensive function calls and returning the cached result when the same inputs occur again.");
			t21 = space();
			h22 = element("h2");
			t22 = text("Usage Example");
			t23 = space();
			p5 = element("p");
			t24 = text("There are many use cases where it is appropriate to cache the result of a method call.  A popular use case is a method that returns the Nth ");
			a5 = element("a");
			t25 = text("Fibonacci");
			t26 = text(" number.  The time taken increases exponentially as you increase N.");
			t27 = space();
			h30 = element("h3");
			t28 = text("With Caching");
			t29 = space();
			create_component(prism2.$$.fragment);
			t30 = space();
			h31 = element("h3");
			t31 = text("Without Caching");
			t32 = space();
			create_component(prism3.$$.fragment);
			t33 = space();
			p6 = element("p");
			t34 = text("As you can see the use of Caching in this example allows us to actually work out the Fib of 1000 in neglegeable time.");
			this.h();
		},
		l(nodes) {
			h1 = claim_element(nodes, "H1", { id: true });
			var h1_nodes = children(h1);
			t0 = claim_text(h1_nodes, "Memoizer");
			h1_nodes.forEach(detach);
			t1 = claim_space(nodes);
			p0 = claim_element(nodes, "P", {});
			var p0_nodes = children(p0);
			t2 = claim_text(p0_nodes, "This is a quick and easy way of adding ");
			a0 = claim_element(p0_nodes, "A", { href: true });
			var a0_nodes = children(a0);
			t3 = claim_text(a0_nodes, "Memoization");
			a0_nodes.forEach(detach);
			t4 = claim_text(p0_nodes, "/Caching to your C# project.");
			p0_nodes.forEach(detach);
			t5 = claim_space(nodes);
			p1 = claim_element(nodes, "P", {});
			var p1_nodes = children(p1);
			a1 = claim_element(p1_nodes, "A", { href: true });
			var a1_nodes = children(a1);
			img0 = claim_element(a1_nodes, "IMG", { src: true, alt: true });
			a1_nodes.forEach(detach);
			t6 = claim_space(p1_nodes);
			a2 = claim_element(p1_nodes, "A", { href: true });
			var a2_nodes = children(a2);
			img1 = claim_element(a2_nodes, "IMG", { src: true, alt: true });
			a2_nodes.forEach(detach);
			t7 = claim_space(p1_nodes);
			a3 = claim_element(p1_nodes, "A", { href: true });
			var a3_nodes = children(a3);
			img2 = claim_element(a3_nodes, "IMG", { src: true, alt: true });
			a3_nodes.forEach(detach);
			p1_nodes.forEach(detach);
			t8 = claim_space(nodes);
			claim_component(prism0.$$.fragment, nodes);
			t9 = claim_space(nodes);
			p2 = claim_element(nodes, "P", {});
			var p2_nodes = children(p2);
			t10 = claim_text(p2_nodes, "Calls to cached method with matching arguments will be cached meaning only the first call with a unique set or args will execute the internal code.");
			p2_nodes.forEach(detach);
			t11 = claim_space(nodes);
			h20 = claim_element(nodes, "H2", { id: true });
			var h20_nodes = children(h20);
			t12 = claim_text(h20_nodes, "Installation");
			h20_nodes.forEach(detach);
			t13 = claim_space(nodes);
			p3 = claim_element(nodes, "P", {});
			var p3_nodes = children(p3);
			t14 = claim_text(p3_nodes, "Add the NuGet package to your project.");
			p3_nodes.forEach(detach);
			t15 = claim_space(nodes);
			claim_component(prism1.$$.fragment, nodes);
			t16 = claim_space(nodes);
			h21 = claim_element(nodes, "H2", { id: true });
			var h21_nodes = children(h21);
			t17 = claim_text(h21_nodes, "Why");
			h21_nodes.forEach(detach);
			t18 = claim_space(nodes);
			p4 = claim_element(nodes, "P", {});
			var p4_nodes = children(p4);
			a4 = claim_element(p4_nodes, "A", { href: true });
			var a4_nodes = children(a4);
			t19 = claim_text(a4_nodes, "Memoization");
			a4_nodes.forEach(detach);
			t20 = claim_text(p4_nodes, " is an optimization technique used primarily to speed up computer programs by storing the results of expensive function calls and returning the cached result when the same inputs occur again.");
			p4_nodes.forEach(detach);
			t21 = claim_space(nodes);
			h22 = claim_element(nodes, "H2", { id: true });
			var h22_nodes = children(h22);
			t22 = claim_text(h22_nodes, "Usage Example");
			h22_nodes.forEach(detach);
			t23 = claim_space(nodes);
			p5 = claim_element(nodes, "P", {});
			var p5_nodes = children(p5);
			t24 = claim_text(p5_nodes, "There are many use cases where it is appropriate to cache the result of a method call.  A popular use case is a method that returns the Nth ");
			a5 = claim_element(p5_nodes, "A", { href: true });
			var a5_nodes = children(a5);
			t25 = claim_text(a5_nodes, "Fibonacci");
			a5_nodes.forEach(detach);
			t26 = claim_text(p5_nodes, " number.  The time taken increases exponentially as you increase N.");
			p5_nodes.forEach(detach);
			t27 = claim_space(nodes);
			h30 = claim_element(nodes, "H3", { id: true });
			var h30_nodes = children(h30);
			t28 = claim_text(h30_nodes, "With Caching");
			h30_nodes.forEach(detach);
			t29 = claim_space(nodes);
			claim_component(prism2.$$.fragment, nodes);
			t30 = claim_space(nodes);
			h31 = claim_element(nodes, "H3", { id: true });
			var h31_nodes = children(h31);
			t31 = claim_text(h31_nodes, "Without Caching");
			h31_nodes.forEach(detach);
			t32 = claim_space(nodes);
			claim_component(prism3.$$.fragment, nodes);
			t33 = claim_space(nodes);
			p6 = claim_element(nodes, "P", {});
			var p6_nodes = children(p6);
			t34 = claim_text(p6_nodes, "As you can see the use of Caching in this example allows us to actually work out the Fib of 1000 in neglegeable time.");
			p6_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h1, "id", "memoizer");
			attr(a0, "href", "https://en.wikipedia.org/wiki/Memoization");
			if (img0.src !== (img0_src_value = "https://img.shields.io/nuget/vpre/Memoizer.NETStandard.svg")) attr(img0, "src", img0_src_value);
			attr(img0, "alt", "Version");
			attr(a1, "href", "https://www.nuget.org/packages/Memoizer.NETStandard");
			if (img1.src !== (img1_src_value = "https://img.shields.io/nuget/dt/Memoizer.NETStandard.svg")) attr(img1, "src", img1_src_value);
			attr(img1, "alt", "Downloads");
			attr(a2, "href", "https://www.nuget.org/packages/Memoizer.NETStandard");
			if (img2.src !== (img2_src_value = "https://github.com/Gaweph/Memoizer/actions/workflows/pr-build-and-test.yml/badge.svg")) attr(img2, "src", img2_src_value);
			attr(img2, "alt", "Test Conversion");
			attr(a3, "href", "https://github.com/Gaweph/Memoizer/actions/workflows/pr-build-and-test.yml");
			attr(h20, "id", "installation");
			attr(h21, "id", "why");
			attr(a4, "href", "https://en.wikipedia.org/wiki/Memoization");
			attr(h22, "id", "usageexample");
			attr(a5, "href", "https://en.wikipedia.org/wiki/Fibonacci");
			attr(h30, "id", "withcaching");
			attr(h31, "id", "withoutcaching");
		},
		m(target, anchor) {
			insert(target, h1, anchor);
			append(h1, t0);
			insert(target, t1, anchor);
			insert(target, p0, anchor);
			append(p0, t2);
			append(p0, a0);
			append(a0, t3);
			append(p0, t4);
			insert(target, t5, anchor);
			insert(target, p1, anchor);
			append(p1, a1);
			append(a1, img0);
			append(p1, t6);
			append(p1, a2);
			append(a2, img1);
			append(p1, t7);
			append(p1, a3);
			append(a3, img2);
			insert(target, t8, anchor);
			mount_component(prism0, target, anchor);
			insert(target, t9, anchor);
			insert(target, p2, anchor);
			append(p2, t10);
			insert(target, t11, anchor);
			insert(target, h20, anchor);
			append(h20, t12);
			insert(target, t13, anchor);
			insert(target, p3, anchor);
			append(p3, t14);
			insert(target, t15, anchor);
			mount_component(prism1, target, anchor);
			insert(target, t16, anchor);
			insert(target, h21, anchor);
			append(h21, t17);
			insert(target, t18, anchor);
			insert(target, p4, anchor);
			append(p4, a4);
			append(a4, t19);
			append(p4, t20);
			insert(target, t21, anchor);
			insert(target, h22, anchor);
			append(h22, t22);
			insert(target, t23, anchor);
			insert(target, p5, anchor);
			append(p5, t24);
			append(p5, a5);
			append(a5, t25);
			append(p5, t26);
			insert(target, t27, anchor);
			insert(target, h30, anchor);
			append(h30, t28);
			insert(target, t29, anchor);
			mount_component(prism2, target, anchor);
			insert(target, t30, anchor);
			insert(target, h31, anchor);
			append(h31, t31);
			insert(target, t32, anchor);
			mount_component(prism3, target, anchor);
			insert(target, t33, anchor);
			insert(target, p6, anchor);
			append(p6, t34);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(prism0.$$.fragment, local);
			transition_in(prism1.$$.fragment, local);
			transition_in(prism2.$$.fragment, local);
			transition_in(prism3.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(prism0.$$.fragment, local);
			transition_out(prism1.$$.fragment, local);
			transition_out(prism2.$$.fragment, local);
			transition_out(prism3.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(h1);
			if (detaching) detach(t1);
			if (detaching) detach(p0);
			if (detaching) detach(t5);
			if (detaching) detach(p1);
			if (detaching) detach(t8);
			destroy_component(prism0, detaching);
			if (detaching) detach(t9);
			if (detaching) detach(p2);
			if (detaching) detach(t11);
			if (detaching) detach(h20);
			if (detaching) detach(t13);
			if (detaching) detach(p3);
			if (detaching) detach(t15);
			destroy_component(prism1, detaching);
			if (detaching) detach(t16);
			if (detaching) detach(h21);
			if (detaching) detach(t18);
			if (detaching) detach(p4);
			if (detaching) detach(t21);
			if (detaching) detach(h22);
			if (detaching) detach(t23);
			if (detaching) detach(p5);
			if (detaching) detach(t27);
			if (detaching) detach(h30);
			if (detaching) detach(t29);
			destroy_component(prism2, detaching);
			if (detaching) detach(t30);
			if (detaching) detach(h31);
			if (detaching) detach(t32);
			destroy_component(prism3, detaching);
			if (detaching) detach(t33);
			if (detaching) detach(p6);
		}
	};
}

// (19:0) <PostContents>
function create_default_slot(ctx) {
	let openingithub;
	let t;
	let postsection;
	let current;

	openingithub = new OpenInGithub({
			props: {
				url: "https://github.com/Gaweph/Memoizer"
			}
		});

	postsection = new PostSection({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(openingithub.$$.fragment);
			t = space();
			create_component(postsection.$$.fragment);
		},
		l(nodes) {
			claim_component(openingithub.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(postsection.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(openingithub, target, anchor);
			insert(target, t, anchor);
			mount_component(postsection, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const postsection_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postsection_changes.$$scope = { dirty, ctx };
			}

			postsection.$set(postsection_changes);
		},
		i(local) {
			if (current) return;
			transition_in(openingithub.$$.fragment, local);
			transition_in(postsection.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(openingithub.$$.fragment, local);
			transition_out(postsection.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(openingithub, detaching);
			if (detaching) detach(t);
			destroy_component(postsection, detaching);
		}
	};
}

function create_fragment(ctx) {
	let postcontents;
	let current;

	postcontents = new PostContents({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(postcontents.$$.fragment);
		},
		l(nodes) {
			claim_component(postcontents.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(postcontents, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const postcontents_changes = {};

			if (dirty & /*$$scope*/ 4) {
				postcontents_changes.$$scope = { dirty, ctx };
			}

			postcontents.$set(postcontents_changes);
		},
		i(local) {
			if (current) return;
			transition_in(postcontents.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(postcontents.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(postcontents, detaching);
		}
	};
}

const title = "Memoizer";
const date = "Tue Oct 05 2021 11:34:37 GMT+0000 (Coordinated Universal Time)";

function instance($$self) {
	const tags = ["nuget"];
	const projects = [];
	return [];
}

class Memoizer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Memoizer;
//# sourceMappingURL=Memoizer.svelte.js.map
